var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75591 10.7022C10.8335 10.7022 11.7071 9.82865 11.7071 8.75102C11.7071 7.6734 10.8335 6.7998 9.75591 6.7998C8.67828 6.7998 7.80469 7.6734 7.80469 8.75102C7.80469 9.82865 8.67828 10.7022 9.75591 10.7022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1854 1.92683C17.1512 1.80976 17.0976 1.69756 17.0195 1.59512C16.8927 1.43415 16.7805 1.22439 16.6585 1L16.5854 0.863415C16.2976 0.331707 15.7366 0 15.122 0H13.0732C12.4585 0 11.8976 0.331707 11.6098 0.863415L11.5366 1C11.4195 1.22439 11.3024 1.43415 11.1756 1.59512C11.0976 1.69268 11.0439 1.80488 11.0098 1.92195H2.92683C1.3122 1.92195 0 3.23415 0 4.84878V12.6537C0 14.2683 1.3122 15.5805 2.92683 15.5805H17.0732C18.6878 15.5805 20 14.2683 20 12.6537V4.84878C20 3.26829 18.7463 1.98537 17.1854 1.92683ZM9.7561 12.6537C7.60488 12.6537 5.85366 10.9024 5.85366 8.75122C5.85366 6.6 7.60488 4.84878 9.7561 4.84878C11.9073 4.84878 13.6585 6.6 13.6585 8.75122C13.6585 10.9024 11.9073 12.6537 9.7561 12.6537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f2aae4c1c1f6ec726919d8ded8c29288.svg";
export { ForwardRef as ReactComponent };